import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';

const useStyles = theme => ({
    root: {
        width: '100%',
    },
    Arrow: {
        flexShrink: 0
    },
    container: {
        maxeight: 440
    },
});

class PageAction extends Component {
    state = {
        theme: {
            direction: 'rtl1'
        }
    }

    handleFirstPageButtonClick = (event) => {
        this.props.onChangePage(event, 0);
    }

    handleNextPageButtonClick = (event) => {
        this.props.onChangePage(event, this.props.page + 1);
    }

    handlePreviousPageButtonClick = (event) => {
        this.props.onChangePage(event, this.props.page - 1)
    }

    handleLastPageButtonClick = (event) => {
        this.props.onChangePage(event, Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1));
    }

    render() {
        const { classes } = this.props;
        return (
            <Typography component="div" className={classes.Arrow}>
                <IconButton onClick={this.handleFirstPageButtonClick}
                    disabled={this.props.page === 0}
                >
                    {this.state.theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
                </IconButton>

                <IconButton onClick={this.handlePreviousPageButtonClick}
                    disabled={this.props.page === 0}>
                    {this.state.theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                </IconButton>

                <IconButton onClick={this.handleNextPageButtonClick}
                    disabled={this.props.page >= Math.ceil(this.props.count / this.props.rowsPerPage) - 1}>
                    {this.state.theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                </IconButton>

                <IconButton onClick={this.handleLastPageButtonClick}
                    disabled={this.props.page >= Math.ceil(this.props.count / this.props.rowsPerPage) - 1}>
                    {this.state.theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
                </IconButton>
            </Typography>
        )
    }
}

export default withStyles(useStyles)(PageAction);